import React from "react";
import { useParams } from "react-router-dom";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

import GraphicEqRoundedIcon from "@mui/icons-material/GraphicEqRounded";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import StandardFileViewerPage from "./StandardFileViewerPage";

export default function AudioViewerPage() {
    const { audioKey } = useParams();

    return (
        <StandardFileViewerPage
            fileKey={audioKey}
            routeSegment="audio"
            mediaBackground="background.media"
            renderMedia={(file) => (
                <Box
                    sx={{
                        minHeight: { xs: 270, sm: 340 },
                        px: { xs: 2, sm: 4 },
                        py: { xs: 3, sm: 5 },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: { xs: 2.5, sm: 4 },
                        background: (theme) =>
                            theme.palette.mode === "dark"
                                ? "radial-gradient(circle at 50% 34%, rgba(31, 184, 94, 0.16), transparent 42%), linear-gradient(145deg, #202923 0%, #151c18 100%)"
                                : "radial-gradient(circle at 50% 34%, rgba(0, 154, 68, 0.14), transparent 42%), linear-gradient(145deg, #f6faf7 0%, #e7f0e9 100%)",
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: 96, sm: 120 },
                            height: { xs: 96, sm: 120 },
                            borderRadius: "50%",
                            display: "grid",
                            placeItems: "center",
                            color: "primary.main",
                            backgroundColor: "background.paper",
                            border: "1px solid",
                            borderColor: "divider",
                            boxShadow: "0 16px 40px rgba(20, 60, 35, 0.12)",
                        }}
                    >
                        <GraphicEqRoundedIcon
                            sx={{ fontSize: { xs: 48, sm: 60 } }}
                        />
                    </Box>
                    <Typography
                        variant="overline"
                        sx={{
                            color: "text.secondary",
                            fontWeight: 800,
                            letterSpacing: "0.14em",
                        }}
                    >
                        Audio
                    </Typography>
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: 760,
                            borderRadius: 2.5,
                            overflow: "hidden",
                            boxShadow: "0 8px 28px rgba(20, 35, 25, 0.1)",
                            "& .rhap_container": {
                                boxShadow: "none",
                                px: { xs: 1.5, sm: 2.5 },
                                py: 1.75,
                                color: "text.primary",
                                backgroundColor: "background.paper",
                            },
                            "& .rhap_time, & .rhap_main-controls-button, & .rhap_volume-button": {
                                color: "text.primary",
                            },
                            "& .rhap_progress-bar, & .rhap_volume-bar": {
                                backgroundColor: "action.selected",
                            },
                            "& .rhap_progress-filled, & .rhap_volume-filled": {
                                backgroundColor: "primary.main",
                            },
                            "& .rhap_progress-indicator, & .rhap_volume-indicator":
                                {
                                    backgroundColor: "primary.main",
                                },
                        }}
                    >
                        <AudioPlayer autoPlay={false} src={file.url} />
                    </Box>
                </Box>
            )}
        />
    );
}
